import React, { useState, useEffect } from 'react';
import { getPdf } from '../../api/PdfUpload';
import { pdfjs } from 'react-pdf';
import { Spin, Modal } from 'antd';
import { useAuth } from '../../context/AuthContext';
import { getPdfFromAzure } from '../../api/PdfUpload';

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const PdfViewer = React.memo(({ accessToken, fileName, status, company }) => {
    const [pdfContent, setPdfContent] = useState(null);
    const [pdfUrl, setPdfUrl] = useState(null);
    const [loading, setLoading] = useState(true);
    const { refreshToken } = useAuth();

    useEffect(() => {
        setLoading(true);
        const loadPdf = async () => {
            try {
                const pdf = await getPdf(accessToken, fileName, status, company);
                if (pdf) {
                    setPdfContent(pdf);
                }
                else {
                    const refreshTokenResponse = await refreshToken();
                    if (refreshTokenResponse) {
                        const pdf = await getPdf(refreshTokenResponse.accessToken, fileName, status, company);
                        setPdfContent(pdf);
                    }

                }
            }
            catch (error) {
                await getPdfFromAzure(fileName).then((response) => {
                    setPdfContent(response);
                }
                ).catch((error) => {
                    showAlert('error', 'Error while fetching pdf');
                });
            } finally {
                setLoading(false);
            }
        };

        loadPdf();
    }, [accessToken, fileName, status, company, refreshToken]);

    useEffect(() => {
        if (!pdfContent) {
            setPdfUrl(null);
            return undefined;
        }

        const nextPdfUrl = URL.createObjectURL(new Blob([pdfContent], { type: 'application/pdf' }));
        setPdfUrl(nextPdfUrl);

        return () => URL.revokeObjectURL(nextPdfUrl);
    }, [pdfContent]);

    const showAlert = (type, message) => {
        Modal[type]({
            title: 'Alert',
            content: message,
        });
    };

    if (loading) {
        return <Spin
            size="large"
            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 420, flex: 1 }}
        />;
    }

    return (
        <div className="pdf-viewer-frame">
            {pdfUrl && (
                <embed className="pdf-viewer-embed" src={`${pdfUrl}#view=FitH`} type="application/pdf" />
            )}
        </div>
    );
});

export default PdfViewer;
